export const Logo = ({ light = false, className = "h-11" }) => {
  const navy = light ? "#FFFFFF" : "#001E52";
  return (
    <svg
      viewBox="0 0 520 150"
      className={`w-auto ${className}`}
      role="img"
      aria-label="PrimeLane Logistics"
      data-testid="site-logo"
    >
      <text
        x="6"
        y="86"
        fontFamily="Outfit, sans-serif"
        fontSize="76"
        fontWeight="800"
        fontStyle="italic"
        letterSpacing="-2"
        fill={navy}
      >
        PRIMELANE
      </text>
      <text
        x="500"
        y="134"
        textAnchor="end"
        fontFamily="Outfit, sans-serif"
        fontSize="42"
        fontWeight="800"
        fontStyle="italic"
        letterSpacing="4"
        fill="#FE6A04"
      >
        LOGISTICS
      </text>
    </svg>
  );
};
